import { Translation } from '@ps/web-shared-components';
import React, { useState } from 'react';

import MitIdRedirect from '@swf/components/MitIdRedirect/MitIdRedirect';

import Prompt from '../../Prompt/Prompt';
import { promptTitleCapitalize } from '../shared.scss';

import {
  TXTWCL_Okay,
  TXTWCL_WeXre_Transferring_You,
  TXTWCL_You_will_be_redirected_to_the__ELL_3
} from './MitIdRedirectRequired.messages.json';

const MitIdRedirectRequired: React.FC = () => {
  const [showMitIdRedirect, setShowMitIdRedirect] = useState(false);
  const handleOpenMitIdRedirect = () => setShowMitIdRedirect(true);
  return (
    <>
      <Prompt
        classes={{ title: promptTitleCapitalize }}
        variant="default"
        title={{ translation: TXTWCL_WeXre_Transferring_You }}
        noCloseButton
        primaryButton={{ translation: TXTWCL_Okay }}
        onPrimaryButtonClick={handleOpenMitIdRedirect}
      >
        <Translation tagName="p" {...TXTWCL_You_will_be_redirected_to_the__ELL_3} />
      </Prompt>
      {showMitIdRedirect && <MitIdRedirect />}
    </>
  );
};

export default MitIdRedirectRequired;
